import { useLazyQuery } from "@apollo/client"
import { useDebouncedValue } from "@mantine/hooks"
import { get } from "lodash-es"
import React, { useEffect, useState } from "react"
import StaticSelector from "../Atoms/StaticSelector"
const DynamicSelector = ({
  query,
  variables = undefined,
  onCompleted = null,
  isServerSide = false,
  ...staticSelectorProps
}) => {
  const [search, setSearch] = useState("")
  const [debouncedSearch] = useDebouncedValue(search, 500)
  const [getData, { data, loading }] = useLazyQuery(query, {
    query: query,
    variables: (isServerSide && {
      first: 10,
      skip: 0,
      query: debouncedSearch,
      ...variables,
    }) || { ...variables },
    onCompleted,
  })

  useEffect(() => {
    getData()
  }, [query, getData])

  let list = []
  if (data) {
    const key = Object.keys(data)[0]
    list = get(data, key, [])
  }
  return (
    <StaticSelector
      loading={loading}
      items={list}
      {...staticSelectorProps}
      onQueryChange={isServerSide ? query => setSearch(query) : undefined}
    />
  )
}

export default DynamicSelector
